import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { englishMessages } from "./en.js";

await i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  supportedLngs: ["en"],
  resources: {
    en: { translation: englishMessages },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
});

export { i18n };
